import { TeachingCreditState } from '../../services/backendService/backendService';

/**
 * Pure helper: does the user's `playedThisWeek` list already contain a
 * play of this exact lesson? Mirrors the backend dedup key
 * (`presentationId + slideCount`) used in `LessonLimitService.getTeachingCreditState`,
 * so a replay never gets blocked at remaining=0.
 */
export const isLessonAlreadyPlayedThisWeek = (
  creditState: TeachingCreditState | undefined,
  presentationId: string,
  slideCount: number,
): boolean =>
  creditState?.playedThisWeek?.some(
    l => l.presentationId === presentationId && l.slideCount === slideCount,
  ) ?? false;
